export default __webpack_public_path__ + "static/media/otp.86a24c8b.svg";